import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectQuickSuggestionOption')(function selectQuickSuggestionOption(option, choice, state) {
    var optionState = state.optionState;
    optionState[option] = choice;
}));
//# sourceMappingURL=selectQuickSuggestionOption.js.map